import { div } from "lqx-react";
import React from "react";
import { DigiTooltip } from "../shared";

export const HeaderTitle = ({ children }: { children: JSX.Element }) => {
    return <DigiTooltip title={ children }>
        <Container>
            { children }
        </Container>
    </DigiTooltip>
}


const Container = div({
    height: '27px',
    marginLeft: '21px',
    marginTop: '5px',
    marginBottom: '10px',
    fontWeight: 500,
    fontSize: '22px',
    lineHeight: '27px',
    color: '#1F2530',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: '50px'
});
